import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Utils from './common/Utils.js';

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
// Silly react-bootstrap modal custom css
// Need this here as the react-bootstrap modal sit outside of the React root element
import './assets/scss/components/reactbootstrapmodal.scss';

const runningInDev = process.env.NODE_ENV === 'development' ? true : false;

// Handle the JS errors globally - always fail silently but log to DB.
// Synchronous errors will hit this global error handler, and also the React Error Boundary if it happens during one of the component lifecycle phases.
// Asynchronous errors will hit this global error handler, and also the React Error Boundary if a component has the useErrorBoundary() hook and showBoundary() state set up.
// Errors hitting the Error Boundary will be logged to DB, and are handled gracefully with page + build refresh UI.
// Errors hitting the global error handler will be logged to DB if they aren't errors returned from an API call.
window.onerror = function (message, source, lineno, colno, error) 
{
    let jsonErrorData = null;
    
    // some browsers e.g. firfox can write diagnostic messages direct to console which get picked up in here
    if (error)
    {
        jsonErrorData = Utils.tryJsonParse(error.message ?? "{}");
    }

    // log diagnostic message, else let error boundary handle api error, else in dev show error and error page
    if (runningInDev && !error)
    {
        console.log("Browser diagnostic message: ", message);
    }
    else if (jsonErrorData?.data?.errors && Object.keys(jsonErrorData.data.errors).length > 0)
    {
        //console.error("logging api error");
    }
    else if (runningInDev)
    {

        const url = process.env.REACT_APP_BASE_API_URL + "/error/weberror";

        let data = {
            "path": window.location.pathname + window.location.search,
            "message": message,
            "errorData": error.stack,
            "errorid": crypto.randomUUID(),
            "site": process.env.REACT_APP_EMBED_SITE
        };

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.text())
            .then(data =>
            {
                //console.error(data);
            })
            .catch(error =>
            {
                // not attempting re-throw here to avoid infinite loop
                //console.error("Failed to log JS error: " + error);
            });
    }
    else
    {
        //console.error("JS error: " + error);
    }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    //<React.StrictMode>
    <>
        <App />
    </>
    //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
